import { quadrantsENUM } from './config/quadrants';
import { ringsENUM } from './config/rings';

const lastUpdate = new Date('2022-11-28');

export default [
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'AWS',
    id: 'AWS',
    title: 'AWS',
    quadrant: quadrantsENUM.PLATAFORMS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Circle CI',
    id: 'Circle CI',
    title: 'Circle CI',
    quadrant: quadrantsENUM.PLATAFORMS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ASSESS,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'GCP',
    id: 'GCP',
    title: 'GCP',
    quadrant: quadrantsENUM.PLATAFORMS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ASSESS,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Open-street-maps',
    id: 'Open-street-maps',
    title: 'Open street maps',
    quadrant: quadrantsENUM.PLATAFORMS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ASSESS,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'readme-com',
    id: 'readme-com',
    title: 'readme.com',
    quadrant: quadrantsENUM.PLATAFORMS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Snowflake',
    id: 'Snowflake',
    title: 'Snowflake',
    quadrant: quadrantsENUM.PLATAFORMS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Montecarlo',
    id: 'Montecarlo',
    title: 'Montecarlo',
    quadrant: quadrantsENUM.PLATAFORMS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Launchdarkly',
    id: 'Launchdarkly',
    title: 'Launchdarkly',
    quadrant: quadrantsENUM.PLATAFORMS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'kubernetes',
    id: 'kubernetes',
    title: 'Kubernetes',
    quadrant: quadrantsENUM.PLATAFORMS,
    description: '',
  },
];